export const PUBLICATION_STATUS = {
    ACTIVE: 'active',
    UNDER_REVIEW: 'under_review',
    PAUSED: 'paused',
    CLOSED: 'closed',
    DELETED: 'deleted',
    INACTIVE: 'inactive',
    PAYMENT_REQUIRED: 'payment_required',
    NOT_YET_ACTIVE: 'not_yet_active'
}

export const INTEGRATION_EXPOSURE_TYPE_NAME = {
    silver: 'Plata',
    gold: 'Oro',
    gold_premium: 'Oro premium',
}

export const ACCOUNT_STATUS = {
    DELETED: 'deleted',
    DISCONNECTED: 'disconnected',
}

export const MESSAGE ={
    UPDATE_STATE_SUCCESS:'Cambiaste el estado de la publicación correctamente.',
    UPDATE_STATE_ERROR:'Algo salió mal, intentá de nuevo en unos minutos.',
    CANCEL_MODAL:'Si cancelás, no se guardará la información que cargaste.',
    SUCCESS:'Aplicaste los cambios en multimedia correctamente.',
    ERROR_UPLOADING_IMAGES:'Estas intentando subir archivos no válidos. Podés subir hasta 50 imágenes, cada una con un tamaño máximo de 10 MB, en formato jpg o png.',
    REQUIRED:'Este campo es obligatorio.',
    SUCCESS_CREATION_SAVINGS_PLAN:'Se creó exitosamente el plan de ahorro',
    SUCCESS_EDIT_SAVINGS_PLAN:'Se edito exitosamente el plan de ahorro',
    FAILURE_CREATION_SAVINGS_PLAN:'Ocurrió un error.',
}
export const PRODUCT_OPTIONS = {
    _0km: '0km',
    usado: 'usado',
    planAhorro: 'plan-ahorro',
}

export const PRODUCT_TYPE = {
    ZERO_KM: '0km',
    USED_CAR: 'Usado',
    USED_CARS: 'Usados',
    SAVINGS_PLAN:'Plan de ahorro',
    

}
export const ROUTE_MODE ={
    CREATE:'crear',
    EDIT:'editar',
    VIEW:'ver',
    DUPLICATE:'duplicar'
}

export const ENDPOINTS_NAME =
{   FILE_SAVINGS_PLAN: 'PLAN',
    MASTER: 'MAESTRO',
    PRODUCT: 'PRODUCTO'
}

export const LABEL={
    MULTIMEDIA:'Imágenes y videos',
    FILES:'Ficha técnica',
    DESCRIPTION:'Descripción',
    BRAND:'Marca',
    MODEL:'Modelo',
    YEAR:'Año',
    VERSION:'Versión',
    PRICE:'Precio sugerido de fábrica',
    ZERO_KM: '0km',
    USADO: 'Usado',
    CANCEL_MODAL_CONFIRM: 'Sí, cancelar',
    CANCEL_MODAL_CANCEL:'volver',
    MULTIMEDIA_CONFIRM:'APLICAR'
}

export const TITLE={
    CARINFO_SECTION:'Información del auto',
    VERSION_SECTION:'Versión de suscripción',
    COLORS_SECTION:'Colores disponibles',
    MULTIMEDIA_SECTION:'Multimedia y descripción',
    CANCEL_MODAL_TITLE:'¿Confirmás que querés cancelar?',
    PRICE_UPDATE:'Actualización de precios',
    IMPORT_RESULT:'Resultado de importación'
}

export const BUTTON_LABEL = {
    CANCEL: 'CANCELAR',
    ACCEPT:'OK',
    CONFIRM_DELETE:'SÍ, ELIMINAR',
}

export const MONEY_TYPE={
    ARS:'PESO'
}

export const ITEM_NAME={
    VIDEO:'video',
    INSTALLMENTS:'installments',
    PRODUCT:'producto',
    INSTALLMENT_VALUE:'subscriptionInstallmentValue'
}

export const ENTITY_NAME={
    PRODUCT:'PRODUCTO',
    PLAN:'PLAN'
}

export const TOOLTIP_MSG={
    PAF:'Porcentaje a financiar',
    VIG:'Vigencia'
}

export const PUBLISHED_STATUS={
    PUBLISH:'PUBLICADO',
    NOT_PUBLISH:'NO PUBLICADO'
}

export const PRICE_TYPE={
    PUBLISH_PRICE:'publishPrice',
    PRODUCT_PRICE:'productPrice'
}

export const BUSINESS_TYPE={
    ZERO_KM: '0Km',
    USED_CAR: 'Usados',
    SAVINGS_PLAN:'SavingsPlan'
}
export const COLUMN_LENGTH = 7
export const COLUMN_LENGTH_MOBILE = 2
export const INPUT_PRICE_MAX_LENGTH = 12
export const MAX_FILES = 50
